import sortBy from 'lodash/sortBy';

export default {
  data() {
    return {
      selectedChannels: [],
    };
  },
  created() {
    this.sortChannelsByFavourite();
  },
  methods: {
    sortChannelsByFavourite(channels) {
      this.selectedChannels = sortBy(channels || this.channels, ({ favourite }) => !favourite);
    },
  },
};
